import { jsx as _jsx } from "react/jsx-runtime";
import { getTestId } from '@airtel/air-design-system';
import { View } from 'react-native';
import { CarouselWidget } from '../../../carousel-widget';
import { breakpoints, getHeroLobWidgetStyles } from '../../HeroLobWidgetStyles';
import { PropositionCard } from './PropositionCard';
export var PropositionCardsCarousel = props => {
  var _a;
  var id = props.id,
    listData = props.listData,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'HeroLobWidgetContainer' : _props$testID,
    onUserAction = props.onUserAction,
    carouselWidgetProps = props.carouselWidgetProps,
    onCardVisibleMetaData = props.onCardVisibleMetaData;
  var widgetStyles = getHeroLobWidgetStyles();
  var list = (_a = listData === null || listData === void 0 ? void 0 : listData.map(item => _jsx(PropositionCard, Object.assign({}, item, {
    onUserAction: onUserAction,
    testID: testID
  })))) !== null && _a !== void 0 ? _a : [];
  var onSlideVisibleHandler = item => {
    onCardVisibleMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, onCardVisibleMetaData), Object.assign({
      index: item === null || item === void 0 ? void 0 : item.index
    }, listData === null || listData === void 0 ? void 0 : listData[item === null || item === void 0 ? void 0 : item.index])));
  };
  return _jsx(View, Object.assign({
    style: widgetStyles.cards
  }, getTestId(testID, 'PropositionCard'), {
    children: _jsx(CarouselWidget, Object.assign({
      data: list,
      carouselType: "COMPONENT",
      showNavigationCounterWithButton: false,
      alignment: "center",
      breakPoints: breakpoints,
      onSlideVisibleHandler: onSlideVisibleHandler,
      inViewStyle: widgetStyles.inViewStyle
    }, carouselWidgetProps))
  }));
};